// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"inspiration-module--image-container--1SVP9","imageGrid":"inspiration-module--image-grid--3tZsx"};